<template lang="pug">
v-dialog(v-model="opened", width="500", :overlay-color="isDark ? '#05090d' : '#000000'")
  v-flex.vitrify.modal-change-delivery(xs12, v-if="opened", :class="{ 'modal-change-delivery--dark': isDark }")
    div.expande-horizontal.wrap.pt-0
      div.expande-horizontal.windows-style.fonte.modal-change-delivery__header(:class="{ 'modal-change-delivery__header--dark': isDark }")
        v-flex(xs12)
          v-list.px-0.mx-0(nav, dense, color="transparent", :dark="isDark")
            v-list-item
              v-avatar.mr-3(:color="isDark ? '#26323b' : '#333'")
                v-icon(color="#f2f2f2") mdi-map-search-outline
              v-list-item-content
                v-list-item-title.fonte.text-xs-center
                  span.fonte Endereço
                v-list-item-subtitle.fonte
                  span.fonte Busque o endereço pelo CEP
              v-list-item-action
                v-avatar(size="31",:color="$theme.primary")
                  v-btn(
                    @click="close"
                    color="#f2f2f2"
                    text
                    small
                    fonte
                  )
                    v-icon mdi-close
      v-flex(xs12).pa-6.pt-6.modal-change-delivery__content
        div.card-method-form.expande-horizontal.wrap.fonte
          v-flex(xs12)
            v-form(ref="payer_form")
              v-flex(xs7)
                v-text-field(
                  dense
                  label="CEP",
                  v-model="get_compra.address.zip_code"
                  filled
                  :color="$theme.primary"
                  :dark="isDark"
                  :background-color="fieldBackground"
                  type="number"
                  ref="cepInput"
                  @input="searchCep"
                  :rules="cepRules"
                  v-mask="['########']"
                  placeholder="########"
                ) 
              div.expande-horizontal
                v-flex(xs9).pr-3
                  v-text-field(
                    dense
                    v-model="get_compra.address.street"
                    label="Endereço",
                    filled
                    :color="$theme.primary"
                    :dark="isDark"
                    :background-color="fieldBackground"
                  )
                v-flex(xs3)
                  v-text-field(
                    dense
                    v-model="get_compra.address.number"
                    label="Nº",
                    ref="addressNumber"
                    @keyup.enter.prevent="saveAddress"
                    filled
                    :color="$theme.primary"
                    :dark="isDark"
                    :background-color="fieldBackground"
                  )
              v-flex(xs12)
                div.expande-horizontal
                  v-flex.mr-3(xs4)
                    v-text-field(
                      v-model="get_compra.address.city"
                      filled
                      :color="$theme.primary"
                      :dark="isDark"
                      :background-color="fieldBackground"
                      dense,
                      label="Cidade",
                      placeholder="ex: Macapá"
                    ) 
                  v-flex.mr-3(xs4)
                    v-text-field(
                      v-model="get_compra.address.state"
                      filled
                      :color="$theme.primary"
                      :dark="isDark"
                      :background-color="fieldBackground"
                      dense,
                      label="Estado",
                      placeholder="ex: Amapá"
                    ) 
                  v-flex(xs6)
                    v-text-field(
                      v-model="get_compra.address.district"
                      filled
                      :color="$theme.primary"
                      :dark="isDark"
                      :background-color="fieldBackground"
                      dense,
                      label="Bairro",
                      placeholder="ex: Zerão"
                    ) 
          v-flex(xs12)
            v-btn.fonte.white--text.elevation-0(rounded,@click="saveAddress",:color="$theme.primary") Salvar        

</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
export default {
  data() {
    return {
      cepRules: [v => !!v || "preencha seu cep"],
      opened: false
    };
  },
  computed: {
    ...mapGetters(["get_compra", "get_clientes"]),
    isDark() {
      return localStorage.dark === "true";
    },
    fieldBackground() {
      return this.isDark ? "#121c24" : "#f5f5f5";
    }
  },
  methods: {
    ...mapActions(["get_cep"]),
    async searchCep() {
      if (this.get_compra.address.zip_code) {
        if (this.get_compra.address.zip_code.length === 8) {
          const res = await axios.get(
            `https://viacep.com.br/ws/${this.get_compra.address.zip_code}/json/`
          );
          if (res.status === 200) {
            this.get_compra.address.street = res.data.logradouro;
            this.get_compra.address.district = res.data.bairro;
            this.get_compra.address.city = res.data.localidade;
            this.get_compra.address.state = res.data.uf;
            this.get_compra.address.bairro = res.data.bairro;
            this.get_compra.address.range_numbers = res.data.complemento;
            this.get_compra.address.number = "";
            this.$refs.addressNumber.focus();
            this.$forceUpdate();
          }
        }
      }
    },
    saveAddress() {
      if (this.$refs.payer_form.validate()) {
        const address = this.get_compra.address;
        this.$store.commit("set_compra", {
          ...this.get_compra,
          address
        });
        this.close();
      }
    },
    open() {
      if (!this.get_compra.address) {
        this.get_compra.address = {};
      }
      this.opened = true;
      setTimeout(() => {
        this.$refs.cepInput.focus();
      }, 300);
    },
    close() {
      this.opened = false;
      setTimeout(() => {
        this.$forceUpdate();
      }, 1000);
    }
  },
  created() {}
};
</script>

<style scoped>
.modal-change-delivery {
  min-height: 10vh;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.96);
  color: #263238;
  border-radius: 8px;
}
.modal-change-delivery--dark {
  background: #0b141a;
  color: #f2f6f8;
  border: 1px solid rgba(255, 255, 255, 0.08);
}
.modal-change-delivery__header {
  background: rgba(255, 255, 255, 0.72);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.modal-change-delivery__header--dark {
  background: #101b22;
  border-bottom-color: rgba(255, 255, 255, 0.08);
}
.modal-change-delivery--dark >>> .v-label,
.modal-change-delivery--dark >>> .v-input input,
.modal-change-delivery--dark >>> .v-input textarea,
.modal-change-delivery--dark >>> .v-list-item__title,
.modal-change-delivery--dark >>> .v-list-item__subtitle {
  color: #f2f6f8 !important;
}
.modal-change-delivery--dark >>> .v-list-item__subtitle,
.modal-change-delivery--dark >>> input::placeholder {
  color: rgba(242, 246, 248, 0.66) !important;
}
.modal-change-delivery--dark >>> .v-text-field--filled > .v-input__control > .v-input__slot {
  border: 1px solid rgba(255, 255, 255, 0.08);
}
.card-method-card {
  max-width: 300px;
}
.card-title {
  color: #363636;
}
.card-container {
  width: 100%;
  display: flex;
  background: #f0f0f0;
  border: 1px solid #0da8f0;
  border-radius: 10px;
}
</style>
